import { __assign, __awaiter, __extends, __generator } from "tslib";
import cn from 'classnames';
import { mmUid } from 'mm-ts-utils';
import ms from 'ms';
import * as React from 'react';
import IdleTimer from 'react-idle-timer';
import { connect } from 'react-redux';
import * as Scroll from 'react-scroll';
import { ChatMessageType } from '../../../../_library/domain-base/BaseChatMessage';
import { wsJoinRoom, wsLeaveRoom } from '../../../../_library/utils/app-ws-room-utils';
import { CUSTOM_MESSAGE_NEXT_INPUT_VALUE_FORCE_NONE, CUSTOM_MESSAGE_ROOM_MARKER__SET_ENTITIES, CUSTOM_MESSAGE_TYPE_MARKER, DUMMY_AUDIO, } from '../../../../consts';
import { config } from '../../../_core/config';
import { getClientConfig, getFromSessionStorage, saveToSessionStorage, } from '../../../_core/utils/app-storage';
import { createDebugLogger } from '../../../_core/utils/app-utils';
import { I18nMsgNs } from '../../../_core/utils/i18n-helpers';
import { domainSelector } from '../../../domain/domain-redux';
import { dispatchOppositeParty } from '../../../domain/opposite-party';
import { dispatchUiState } from '../../../domain/ui-state';
import { identitySelector } from '../../../identity/identity-redux';
import { _detectOppositeParty } from '../../actions/_detect-opposite-party';
import { chatAction } from '../../chat-redux';
import { ChatMessage } from '../../ChatMessage';
import ChatInput from '../ChatInput/ChatInput';
import { Messages } from '../Messages/Messages';
import { TypingUsers } from '../TypingUsers/TypingUsers';
import './ChatThread.scss';
import ChatThreadDebugInfo from './ChatThreadDebugInfo';
import { isEqual } from 'lodash';
import { ToastProvider } from 'react-toast-notifications';
import { dataLayerPush } from '../../../../../../client-externals/utils';
var Msg = I18nMsgNs('ChatThread');
// POZNAMKY K PROBLEMU SO SCROLOVANIM SU DOLE...
var ChatThreadClass = /** @class */ (function (_super) {
    __extends(ChatThreadClass, _super);
    function ChatThreadClass(props) {
        var _this = _super.call(this, props) || this;
        _this.debug = createDebugLogger('ChatThread');
        _this.msgSound = new Audio();
        _this.$scrollContainer = React.createRef();
        _this.unlockAudio = function () { return __awaiter(_this, void 0, void 0, function () {
            var originalSrc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        originalSrc = this.msgSound.src;
                        this.msgSound.src = DUMMY_AUDIO;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, this.msgSound.play()];
                    case 2:
                        _a.sent();
                        this.msgSound.pause();
                        this.msgSound.currentTime = 0;
                        return [3 /*break*/, 4];
                    case 3:
                        this.msgSound.src = originalSrc;
                        return [7 /*endfinally*/];
                    case 4:
                        document.removeEventListener('click', this.unlockAudio);
                        document.removeEventListener('touchstart', this.unlockAudio);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.scrollToBottom = function (duration, smooth) {
            if (duration === void 0) { duration = 200; }
            if (smooth === void 0) { smooth = true; }
            setTimeout(function () {
                Scroll.animateScroll.scrollToBottom({
                    duration: duration,
                    smooth: smooth,
                    delay: 0,
                    containerId: 'scrollContainer',
                    isDynamic: true,
                    // neviem co to interne robi, ale zda sa, ze to fixlo issue...
                    ignoreCancelEvents: true,
                });
            }, 100);
        };
        _this.submitMessage = function (value, type, meta) {
            if (meta === void 0) { meta = {}; }
            return ChatThreadClass.submitMessage(_this.props, value, type, meta);
        };
        _this.sendAbTestEvent = function () {
            var _a, _b;
            var variantId = getFromSessionStorage('variantId');
            var lastVariantId = (_b = (_a = _this.props.lastMessage) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.variantId;
            var isEligibleVariant = ['buttons', 'original'].includes(lastVariantId);
            if ((!variantId || variantId === 'notset') && lastVariantId) {
                saveToSessionStorage('variantId', lastVariantId);
                if (isEligibleVariant) {
                    dataLayerPush({
                        session: {
                            abtests: [
                                {
                                    testId: 'buttons',
                                    variantId: lastVariantId,
                                },
                            ],
                        },
                    });
                }
            }
        };
        if (!_this.props.threadId) {
            throw new Error('Missing expected threadId prop');
        }
        _this.msgSound = new Audio();
        _this.msgSound.autoplay = true;
        // onClick of first interaction on page before I need the sounds
        // (This is a tiny MP3 file that is silent and extremely short - retrieved from https://bigsoundbank.com and then modified)
        _this.msgSound.src =
            'data:audio/mpeg;base64,SUQzBAAAAAABEVRYWFgAAAAtAAADY29tbWVudABCaWdTb3VuZEJhbmsuY29tIC8gTGFTb25vdGhlcXVlLm9yZwBURU5DAAAAHQAAA1N3aXRjaCBQbHVzIMKpIE5DSCBTb2Z0d2FyZQBUSVQyAAAABgAAAzIyMzUAVFNTRQAAAA8AAANMYXZmNTcuODMuMTAwAAAAAAAAAAAAAAD/80DEAAAAA0gAAAAATEFNRTMuMTAwVVVVVVVVVVVVVUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQsRbAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQMSkAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV';
        _this.handleOnAction = _this.handleOnAction.bind(_this);
        _this.handleOnActive = _this.handleOnActive.bind(_this);
        _this.handleOnIdle = _this.handleOnIdle.bind(_this);
        return _this;
    }
    ChatThreadClass.prototype.shouldComponentUpdate = function (nextProps) {
        // Rendering the component only if
        // passed props value is changed
        var shouldUpdate = false;
        if (!isEqual(nextProps.messages, this.props.messages)) {
            shouldUpdate = true;
        }
        else if (!isEqual(nextProps.lastMessage, this.props.lastMessage)) {
            shouldUpdate = true;
        }
        else if (!isEqual(nextProps.identity, this.props.identity)) {
            shouldUpdate = true;
        }
        else if (this.props.threadUpdated !== nextProps.threadUpdated) {
            shouldUpdate = true;
        }
        else if (this.props.isAgent !== nextProps.isAgent) {
            shouldUpdate = true;
        }
        else if (this.props.useMsgSound !== nextProps.useMsgSound) {
            shouldUpdate = true;
        }
        else if (this.props.chatInputHidden !== nextProps.chatInputHidden) {
            shouldUpdate = true;
        }
        else if (this.props.threadId !== nextProps.threadId) {
            shouldUpdate = true;
        }
        // console.log('COMPONENT SHOULD UPDATE: ', shouldUpdate);
        return shouldUpdate;
    };
    ChatThreadClass.prototype.componentDidMount = function () {
        var _a = getClientConfig(), TIMEOUT_NOTIFICATION_TIME = _a.TIMEOUT_NOTIFICATION_TIME, TIMEOUT_TIME = _a.TIMEOUT_TIME, MSG_SOUND_SRC = _a.MSG_SOUND_SRC, IS_MSG_SOUND_ENABLED = _a.IS_MSG_SOUND_ENABLED;
        dispatchUiState(this.props.dispatch, {
            chat_input_hidden: false,
            chat_input_disabled: false,
        });
        this.idleTimer = null;
        this.notificationTimeout =
            TIMEOUT_NOTIFICATION_TIME && ms(TIMEOUT_NOTIFICATION_TIME);
        this.timeout = TIMEOUT_TIME && ms(TIMEOUT_TIME);
        this.scrollToBottom(0, false);
        this.useSound = Boolean(IS_MSG_SOUND_ENABLED) || false;
        document.addEventListener('click', this.unlockAudio);
        document.addEventListener('touchstart', this.unlockAudio);
    };
    ChatThreadClass.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        var MSG_SOUND_SRC = getClientConfig().MSG_SOUND_SRC;
        Object.entries(this.props).forEach(function (_a) {
            var key = _a[0], val = _a[1];
            return prevProps[key] !== val && console.log("DEBUG:  Prop '".concat(key, "' changed"));
        });
        if (this.state) {
            Object.entries(this.state).forEach(function (_a) {
                var key = _a[0], val = _a[1];
                return prevState[key] !== val && console.log("DEBUG: State '".concat(key, "' changed"));
            });
        }
        var prevLength = (prevProps.messages || []).length;
        var length = (this.props.messages || []).length;
        if (prevLength < length) {
            if (prevLength &&
                !this.props.lastMessage.isTransientLike &&
                this.props.lastMessage.authorType !== ChatMessage.AUTHOR_TYPE_USER &&
                this.useSound &&
                this.props.useMsgSound) {
                // it's needed to always seek audio to play for every message
                // see https://jira.sazka.cz/browse/CHU-332
                var msgSound = MSG_SOUND_SRC ||
                    'https://notificationsounds.com/storage/sounds/file-sounds-1148-juntos.mp3';
                if (this.msgSound.src !== msgSound) {
                    this.msgSound.src = msgSound;
                }
                this.msgSound.currentTime = 0;
                this.msgSound.play().catch(function (e) { return console.warn(e); });
            }
            prevLength ? this.scrollToBottom() : this.scrollToBottom(0, false);
        }
        var oppositeParty = _detectOppositeParty(this.props.messages);
        if (oppositeParty === 'agent' && this.props.isAgent === false) {
            dispatchOppositeParty(this.props.dispatch, true);
        }
    };
    ChatThreadClass.prototype.handleOnAction = function (event) {
        console.log('Idle timer interrupted. Activity captured.', event);
    };
    ChatThreadClass.prototype.handleOnActive = function () {
        clearTimeout(this.timeoutId);
        console.log('Remaining time of idle timer = ', this.idleTimer.getRemainingTime());
    };
    ChatThreadClass.prototype.handleOnIdle = function () {
        var _this = this;
        var _a = getClientConfig(), TIMEOUT_NOTIFICATION_MSG = _a.TIMEOUT_NOTIFICATION_MSG, TIMEOUT_MSG = _a.TIMEOUT_MSG;
        this.submitMessage('Notification', ChatMessageType.WIDGET, {
            message: TIMEOUT_NOTIFICATION_MSG,
            hideInput: false,
        });
        this.timeoutId = setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.idleTimer.pause();
                        return [4 /*yield*/, this.submitMessage('Notification', ChatMessageType.END, {
                                message: TIMEOUT_MSG,
                                hideInput: true,
                            })];
                    case 1:
                        _b.sent();
                        this.submitMessage(JSON.stringify({
                            type: CUSTOM_MESSAGE_TYPE_MARKER,
                            room: CUSTOM_MESSAGE_ROOM_MARKER__SET_ENTITIES,
                            payload: (_a = {},
                                _a[CUSTOM_MESSAGE_NEXT_INPUT_VALUE_FORCE_NONE] = true,
                                _a.named_entities = {
                                    RPT_Inactive_Chat: 'yes',
                                },
                                _a),
                        }), ChatMessageType.HIDDEN);
                        return [2 /*return*/];
                }
            });
        }); }, this.timeout);
    };
    ChatThreadClass.prototype.getSnapshotBeforeUpdate = function (prevProps, prevState) {
        var prevLength = (prevProps.messages || []).length;
        console.log('🚀 ~ file: ChatThread.tsx ~ line 210 ~ ChatThreadClass ~ prevLength', prevLength);
        var length = (this.props.messages || []).length;
        console.log('🚀 ~ file: ChatThread.tsx ~ line 212 ~ ChatThreadClass ~ length', length);
        // Are we adding new items to the list?
        // Capture the scroll position so we can adjust scroll later.
        if (prevLength < length) {
            return this.$scrollContainer.current.scrollTop;
        }
        return null;
    };
    ChatThreadClass.prototype.componentWillUnmount = function () {
        var threadId = this.props.threadId;
        threadId && wsLeaveRoom(threadId);
    };
    ChatThreadClass.prototype.render = function () {
        var _this = this;
        var _a = this.props, identity = _a.identity, threadId = _a.threadId, messages = _a.messages, threadUpdated = _a.threadUpdated;
        var B = config.css.B('-chat-thread');
        threadId && wsJoinRoom(threadId);
        this.sendAbTestEvent();
        return (React.createElement("div", { className: cn(B) },
            React.createElement(ToastProvider, { placement: "top-center" },
                this.timeout && (React.createElement(IdleTimer, { ref: function (ref) {
                        _this.idleTimer = ref;
                    }, timeout: this.notificationTimeout, onActive: this.handleOnActive, onIdle: this.handleOnIdle, onAction: this.handleOnAction, debounce: 250 })),
                React.createElement(ChatThreadDebugInfo, { threadId: threadId }),
                React.createElement("div", { className: cn("".concat(B, "__messages")), id: "scrollContainer", ref: this.$scrollContainer },
                    React.createElement(Messages, { identity: identity, messages: messages, threadLastUpdated: threadUpdated, submitMessage: this.submitMessage, scrollToBottom: this.scrollToBottom }),
                    React.createElement(TypingUsers, { parentContainer: this.$scrollContainer, threadId: threadId, 
                        // excludeUserIds={[(identity || ({} as any)).id].filter((v) => !!v)}
                        threadLastUpdated: threadUpdated, scrollToBottom: this.scrollToBottom })),
                !this.props.chatInputHidden && (React.createElement("div", { className: cn("".concat(B, "__input")) },
                    React.createElement(ChatInput, { threadId: threadId, submitMessage: this.submitMessage, inputPlaceholder: this.props.inputPlaceholder }))))));
    };
    ChatThreadClass.submitMessage = function (_a, value, type, meta) {
        var _b, _c;
        var dispatch = _a.dispatch, identity = _a.identity, threadId = _a.threadId, _d = _a.lastMessage, lastMessage = _d === void 0 ? null : _d;
        if (meta === void 0) { meta = {}; }
        var msg = new ChatMessage({
            id: mmUid(),
            thread_id: threadId,
            user_id: (identity || {}).id,
            body: "".concat(value).trim(),
            type: type || undefined,
            meta: meta || {},
        });
        if (lastMessage) {
            // ensure new message created prop is always 1ms newer than last message in state
            var latestCreateAt = ((_b = lastMessage.created) === null || _b === void 0 ? void 0 : _b.getTime()) || Date.now();
            var msgCreatedAt = ((_c = msg.created) === null || _c === void 0 ? void 0 : _c.getTime()) || Date.now();
            var latestTimestamp = Math.max(latestCreateAt, msgCreatedAt);
            var newDate = new Date(latestTimestamp + 1);
            msg.created = newDate;
        }
        return dispatch(chatAction.saveMessage(identity, msg));
    };
    return ChatThreadClass;
}(React.Component));
export { ChatThreadClass };
// MM POZNAMKA: povodne som sa snazil optimalizovat cez nizsiu referenciu (kvoli
// react node compare) ale ukazuje sa to problematicke (napr. pri skrolovani), lebo
// prevProps.messages.length a this.props.messages.length nikdy nie su rozdielne...
// celkovo to asi nebol dobry napad a je to slepa ulicka...
// let _messages = [];
var mapStateToProps = function (state, ownProps) {
    var threadId = ownProps.threadId;
    // const thread = domainSelector.getThread(state)(threadId);
    var _messages = domainSelector.getThreadMessages(state)(threadId);
    state.domain.chat_message;
    // for custom hackings (if needed)...
    if (typeof ChatThreadClass.messageTransformerOrFilter === 'function') {
        _messages = ChatThreadClass.messageTransformerOrFilter(_messages);
    }
    // vid komentar vyssie
    // note: nizsie tance nikdy netrigernu render kedze robime nad referenciou (ale
    // to tak chceme)
    // _messages.length = 0; // truncate
    // _messages.push(..._msgs); // push
    //
    // prettier-ignore
    var lastUpdated = _messages.reduce(function (memo, m) { return Math.max(memo, new Date(m.created).valueOf()); }, 0);
    var useMsgSound = domainSelector.getUseMsgSound(state);
    var lastMsg = domainSelector.getLastThreadMessage(state)(threadId);
    var lastMessage = new ChatMessage(__assign({}, lastMsg));
    var isAgent = domainSelector.getOppositeParty(state);
    // cokolvek sa stalo vyssie, ak nesedi pocet, urcite chceme prerenderovat...
    // toto moze mat zmysel pri roznych transient messagoch, ktore sa pridavaju
    // na klientovi mimo `last_updated` db hodnot (isTyping a pod)...
    // if (ownProps.messagesCount !== _messages.length) {
    //     threadUpdated = new Date().valueOf();
    // }
    var uiState = domainSelector.getUIState(state);
    return {
        threadId: threadId,
        identity: identitySelector.getIdentity(state),
        threadUpdated: lastUpdated,
        useMsgSound: useMsgSound === undefined ? true : useMsgSound,
        lastMessage: lastMessage,
        messages: _messages,
        isAgent: isAgent,
        chatInputHidden: uiState.chat_input_hidden || (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.meta.isChatInputHidden),
    };
};
var mapDispatchToProps = function (dispatch, ownProps) {
    return ({
        dispatch: dispatch,
    });
};
export var ChatThread = connect(mapStateToProps, mapDispatchToProps)(ChatThreadClass);
// lebo react-loadable s defaultnym exportom vyzaduje menej roboty
export default ChatThread;
/**
 * UPDATE - NAKONIEC JE VSETKO INAK: ukazuje sa, ze chyba bola v definicii Loadable
 * kde sa zakazdym vytvarala nova instancia komponentov...
 *
 * NIZSIE NEPLATI... LOADABLE JE OK
 *
 * MISC POZNAMKY K PROBLEMU SO SKROLOVANIM, KYM NEZABUDNEM... (nemusia suvisiet spolu - vela issues sa prelinalo)
 * - tym, ze renderujeme cez Loadable, vsetko je asynchronne a v case renderu
 *   ma wrapper nulovu vysku, preto veci z dokumentacie ku getSnapshotBeforeUpdate
 *   nefunguju
 * - rovnako scroll pozicia je pred updatom vzdy nula
 * - povodna (premature) optimalizacia v mapStateToProps (referencia na messages) sa ukazala byt
 *   uplne kontraproduktivna, lebo prevProps.messages.length a this.props.messages.length
 *   nikdy neboli rozdielne
 * - skusal som to VSELIJAK ohybat ale neuspesne.
 * - dalsi problem bol, ze jednotlive <Messages .../> boli renderovane iba cez
 *   Array.map a teda nemali spolocneho rodica, ktoremu sa dala merat vyska (co bol
 *   easy fix, ale chvilu to trvalo uvedomit si)
 * - problemy boli jednak scrollovat a jednak neskocit na 0 pred zacatim noveho scrollu
 * - skok na nula sa ukazal byt v enter keyDown, kedy sa nerobil submit spravne...
 *
 * Nedokonale, ale good enough riesenie aktualne je:
 * 1. pocuvame na onScroll a ukladame si priebezne poziciu (vsetko in memory)
 * 2. vyssie dva udaje su uz dost na to aby sme vedeli reagovat - ak dojde k zvacseniu
 *    vysky a zaroven mame ulozenu poslednu scroll poziciu, tak hned po renderi
 *    setneme scrollTo (co setne prave vyrenderovani kontajner na rovnaku poziciu
 *    a teda neskoci na 0) a az nasledne zavolame animateScroll
 *    ... je tu vsak potencialne issue, ze ak by nejaky widget mal menit vysku, mozno
 *    to bude treba fixovat
 *
 * Problem co ostava je napr. ked message obsahuju obrazky, ktore sa nacitavaju... tam
 * je meranie vysky problematicke
 */
